var leanStorage = ( function() {
	var storageMechanism = 'cookie';
	try {
		if (window.localStorage) {
			window.localStorage['ls-test'] = '';
			window.localStorage.removeItem('ls-test');
			storageMechanism = 'localStorage';
		}
	} catch (error) { /* localStorage not fully supported */}
	return {
		getFromStorage: getFromStorage,
		setInStorage: setInStorage
	};

	function getFromStorage(key) {
		if (storageMechanism === 'localStorage') {
			return returnValue(window.localStorage[key]);
		} else {
			return getCookie(key);
		}
	}

	function setInStorage(key, value) {
		if (storageMechanism === 'localStorage') {
			window.localStorage.setItem(key, value);
		} else {
			setCookie(key, value);
		}
	}

	function getCookie(key) {
		var name = key + '=';
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		var value = '';
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				value = c.substring(name.length, c.length);
			}
		}
		return returnValue(value);
	}

	function setCookie(key, value) {
		var m = moment().add(365, 'days');
		document.cookie = key + '=' + value + ';expires=' + m._d.toUTCString() + ';path=/';
	}

	function returnValue(value) {
		if (value && (value.charAt(0) === '{' || value.charAt(0) === '[' || isStringNumber(value))) {
			return angular.fromJson(value);
		}
		return value;
	}
})();